import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { RootState, useAppDispatch, useAppSelector } from '../../../redux';
import { loadSprint, deleteSprint } from '../../../redux';
import { Icon, Button } from '../../../components';

function SprintDelete() {
    const { t }    = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    let { id }     = useParams();

    const { sprint, deleting, deleted } = useAppSelector((state: RootState) => state.sprints);

    useEffect(() => {
        if (id)
            dispatch(loadSprint(id));
    }, [dispatch, id]);

    const doDelete = () => {
        dispatch(deleteSprint(sprint._id));
    };

    if (deleted)
        navigate('/sprints');

    return (
        <div className="SprintDelete">
            <header className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 px-4 py-0 sm:px-6 lg:px-8">
                <div className="my-2 mx-auto lg:flex lg:items-center lg:justify-between">
                    <div>
                        <h2 className="flex items-center text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
                            <Icon type="sprint" size={7} />&nbsp;
                            { t('sprints.delete_sprint', {name: sprint?.name}) }
                        </h2>
                    </div>
                </div>
            </header>
            <main className="mx-6 my-6">
                {sprint && (sprint._id === id) && (
                <div className="flex">
                    <div className="w-fit mx-auto">
                        <h1 className="mx-auto font-bold p-2 mb-2">
                            { t('sprints.sure_to_delete_sprint', {name: sprint?.name}) }
                        </h1>
                        <div className="mt-5 flex justify-evenly">
                            <Button title={t('common.cancel')} color="navigateBack" to={`/sprints/${sprint?._id}`} icon="back" />
                            <Button
                                onClick={doDelete}
                                title={t('common.delete')}
                                icon="delete"
                                loading={deleting === 'pending'}
                                color="danger"
                            />
                        </div>
                    </div>
                </div>
                )}
            </main>
        </div>
    );
}

export default SprintDelete;
